import { useEffect } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { checkAuth } from "@/auth/useAuth";

const apiBase = (): string => (import.meta.env.VITE_API_URL ?? "") as string;

/** Post-login landing for the BFF cookie flow.
 *
 *  The backend's GET /auth/callback exchanges the Keycloak code, sets the
 *  HttpOnly egpt_session + egpt_refresh cookies, and redirects the browser
 *  here. We confirm the session is live (/auth/me) and forward to the saved
 *  destination. If the session didn't take, restart the login. */
export function AuthCallback() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const dest = params.get("from") || "/workspace";

  useEffect(() => {
    let cancelled = false;
    checkAuth(apiBase()).then((user) => {
      if (cancelled) return;
      if (user) navigate(dest, { replace: true });
      else navigate(`/login?from=${encodeURIComponent(dest)}`, { replace: true });
    });
    return () => {
      cancelled = true;
    };
  }, [navigate, dest]);

  return (
    <Box sx={{ display: "grid", placeItems: "center", height: "100vh", gap: 2 }}>
      <CircularProgress />
      <Typography variant="body2" color="text.secondary">
        Signing you in…
      </Typography>
    </Box>
  );
}
